import React from 'react';
import AboutCom from "../../Components/about/AboutCom";
import Footer from "../../Components/Footer/Footer";
import styled from "styled-components";
const About = () => {
    return (
        <Div>
            <AboutCom/>
            <div className="footer">
                <Footer/>

            </div>
        </Div>
    );
};
const Div = styled.div`
  width: 100%;
  margin: auto;

  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 100%;
    @media  (max-width: 678px){
      position: relative;
      bottom: -10vh;
      left: 0;
    }
  }


`
export default About;